module.exports = __webpack_public_path__ + "static/media/mairie-de-noisy-le-grand-collectivite-locale-noisy-le-grand.62f3ea1c.png";